import BaseComponent from '../BaseComponent';
import EventHandler from '../../utils/dom/event-handler';
import Manipulator from '../../utils/dom/manipulator';
import { localStorage } from '../../utils/storage';

const NAME = 'CoachNotificationBanner';

class CoachNotificationBanner extends BaseComponent {
	constructor(element) {
		super(element);
		this.initAlert();
	}

	static get NAME() {
		return NAME;
	}

	initAlert() {
		const element = this._element;
		const { id: elementId, timestamp } = Manipulator.getDataAttributes(element);
		if (elementId) {
			const previousTimestamp = +localStorage.getItem(elementId);

			if (timestamp - previousTimestamp > 0) {
				element.classList.remove('u-hidden');
			} else {
				element.remove();
			}

			const closeElement = element.querySelector('.lta-btn');

			EventHandler.on(closeElement, 'click', () => {
				localStorage.setItem(elementId, timestamp || 0);
				element.remove();
			});
		}
	}
}

export default CoachNotificationBanner;
